import { logEvent } from "firebase/analytics";

import { analytics } from "../firebase/firebase";

const pendingEvents = [];
let flushTimer = null;

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) =>
      value !== undefined && value !== null && value !== ""
    )
  );
}

export function trackConversionEvent(eventName, params = {}) {
  if (!eventName) return false;

  if (!analytics) {
    pendingEvents.push({ eventName, params: cleanParams(params), attempts: 0 });
    if (!flushTimer && typeof window !== "undefined") {
      flushTimer = window.setInterval(() => {
        if (analytics) {
          pendingEvents.splice(0).forEach((entry) => {
            try { logEvent(analytics, entry.eventName, entry.params); } catch (_error) {}
          });
          window.clearInterval(flushTimer);
          flushTimer = null;
        } else {
          pendingEvents.forEach((entry) => { entry.attempts += 1; });
          if (pendingEvents.every((entry) => entry.attempts >= 10)) {
            pendingEvents.length = 0;
            window.clearInterval(flushTimer);
            flushTimer = null;
          }
        }
      }, 500);
    }
    return false;
  }

  try {
    logEvent(analytics, eventName, cleanParams(params));
    return true;
  } catch (_error) {
    return false;
  }
}

// La source d'un lien partage (?src=facebook…) est memorisee pour la duree
// de la visite (sessionStorage) : l'adresse change ensuite (navigation,
// connexion), et la connexion ou l'inscription etaient comptees « direct ».
const SHARE_ATTRIBUTION_STORAGE_KEY = "karango.share.attribution";
const SHARE_SOURCE_PATTERN = /^[a-z0-9_-]{1,24}$/i;

function readStoredShareAttribution() {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(SHARE_ATTRIBUTION_STORAGE_KEY) || "null");
    if (stored && SHARE_SOURCE_PATTERN.test(String(stored.shareSource || ""))) {
      return { shareSource: stored.shareSource, shareRevision: stored.shareRevision || null };
    }
  } catch (_error) {}
  return null;
}

export function readShareAttribution(location = window.location) {
  try {
    const params = new URLSearchParams(location?.search || "");
    const shareSource = String(params.get("src") || "").trim() || null;
    const shareRevision = String(params.get("v") || "").trim() || null;
    if (shareSource && SHARE_SOURCE_PATTERN.test(shareSource)) {
      try {
        window.sessionStorage.setItem(SHARE_ATTRIBUTION_STORAGE_KEY, JSON.stringify({ shareSource, shareRevision }));
      } catch (_error) {}
      return { shareSource, shareRevision };
    }
    return readStoredShareAttribution() || { shareSource, shareRevision };
  } catch (_error) {
    return { shareSource: null, shareRevision: null };
  }
}
